import React, { useState, useEffect, useRef, useReducer } from "react";
import './Search.css'
import { Dropdown, Button, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import {PulseLoader } from "react-spinners";
import { validEmail } from '../../../../Constants/RegExp';
import IconButton from '@mui/material/IconButton';
import CreateIcon from '@mui/icons-material/Create';
import { ToastContainer} from "react-toastify";
import {
    GetCustomers,
    AddCustomer,
    GetAppointments,
    GetBarbers,
    GetServices,
    GetConfig,
    CancelAppointment,
    GetServiceDurations,
    GetEvents,
    EditAppointment,
    SendCommunication
} from './Requests';
import {
    notifySuccess,
    notifyError
} from '../Response/ResposeHandler'
import dayjs from 'dayjs';
import Select from "react-select";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import Swal from "sweetalert2";
import moment from 'moment';

  const initialState = false;
  
  const reducer = (state, action) =>{
    switch (action.type){
        case 'addCustomerOpen':
          return { ...state, addCustomer: true }
        case 'addCustomerClose':			
          return { ...state, addCustomer: false }
        case 'appointmentsOpen':
            return { ...state, appointment: true }
        case 'appointmentsClose':			
            return { ...state, appointment: false }
        case 'appointmentDetailsOpen':
            return { ...state, appointmentDetails: true }
        case 'appointmentDetailsClose':			
            return { ...state, appointmentDetails: false }
        case 'sendCommunicationOpen':
            return { ...state, sendCommunication: true }
        case 'sendCommunicationClose':			
            return { ...state, sendCommunication: false }
        case 'sendGeneralCommunicationOpen':
            return { ...state, sendGeneralCommunication: true }
        case 'sendGeneralCommunicationClose':			
            return { ...state, sendGeneralCommunication: false }
        default:
        return state	
    }	
  }

  const daysOfWeek = [
    'Sun',
    'Mon',
    'Tue',
    'Wed',
    'Thur',
    'Fri',
    'Sat'
  ]

  const DaysToDisplay = [
    'Sun',
    'Mon',
    'Tue',
    'Wed',
    'Thur',
    'Fri',
    'Sat'
  ]
  
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'June',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dev'
  ]

  const fullDaysOfWeek = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday'
  ]

const Search = () => {
    const [config, setConfig] = useState()
    const [state, dispatch] = useReducer(reducer, initialState);
    const [keyword, setKeyword] = useState("")
    const [showSearchButton, setShowSearchButton] = useState(false)
    const [isLoading, setIsloading] = useState(false)
    const [customers, setCustomer] = useState("")
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [mobile, setMobile] = useState();
    const [email, setEmail] = useState('');
    const [customerNotes, setCustomerNotes] = useState('');
    const [customerBlocked, setCustomerBlocked] = useState();
    let customerErrorsObj = { customerFirstName: '', customerLastName: '', customerMobile: '', customerEmail: '', customerNotes: '' };
    const [customerErrors, setCustomerErrors] = useState(customerErrorsObj);
    const [appointmentsLoading, setAppointmentsLoading] = useState(false)
    const [futureAppointments, setFutureAppointments] = useState([])
    const [allAppointments, setAllAppointments] = useState([])
    const [pastAppointments, setPastAppointments] = useState([])
    const [barbers, setBarbers]= useState([])
    const [services, setServices]= useState([])
    const [isAppointmentCancelled, setIsAppointmentCancelled] = useState();
    const [appointmentCancelledByMessage, setAppointmentCancelledByMessage] = useState();
    const [selectedBarber, setSelectedBarber] = useState();
    const [selectedService, setSelectedService] = useState();
    const [startDateTime, setStartDateTime] = useState();
    const [endDateTime, setEndDateTime] = useState();
    const [duration, setDuration] = useState();
    const [appointmentNotes, setAppointmentNotes] = useState('')
    const [cancelledBy, setCancelledBy] = useState()
    const [appointmentIdToEdit, setAppointmentIdToEdit] = useState();
    const [appointmentModalDisabled, setAppointmentModalDisabled] = useState(false)
    const [timeSelection, setTimeSelection] = useState([])
    let appointmentErrorsObj = { barber: '', service: '', date: '', duration: '', appointmentNotes: '', customer:'' };
    const [appointmentErrors, setAppointmentErrors] = useState(appointmentErrorsObj);
    const [minStep, setMinStep] = useState(20)
    const [customerDetailsObject, setCustomerDetailsObject] = useState()
    const [communicationType, setCommunicationType] = useState()
    const [customerAppointmentChangeMessage, setCustomerAppointmentChangeMessage] = useState()
    const [generalMessage, setGeneralMessage] = useState()
    const [barberList, setBarberList] = useState([])
    const [eventData, setEventData] = useState();
    const [barbersWithClash, setBarbersWithClash] = useState([])
      useEffect(() => {
        GetBarbersWrapper()
    }, []);

    function GetBarbersWrapper()
    {
        GetBarbers().then((res) => {
            setBarbers(res.data)
            var barberListArray = []
            res.data.forEach(element => {
                var obj = { value: element.barberId, label: element.name, isDisabled: element.status === 1 ? false : true }
                barberListArray.push(obj)
              });
                setBarberList(barberListArray)
        }).catch((error) => {

        }).finally((f) => {
            GetServicesWrapper()
        })
    }

    function GetServicesWrapper()
    {
        GetServices().then((res) => {
            var tempVar = []
            // eslint-disable-next-line
            res.data.map((item, index) => {
                var obj = { value: item.serviceId, label: item.name, duration: item.duration, isDisabled: item.status === 1 ? false : true }
                tempVar.push(obj)
            })
            setServices(tempVar)
        }).catch((error) => {

        }).finally((f) => {
            GetServiceDurationsWrapper()
        })
    }

      function GetServiceDurationsWrapper() {
        GetServiceDurations().then((res) => {
          setTimeSelection(res.data)
        }).catch((error) => {
          notifyError("Unable to retrieve service durations, please try again")
        }).finally(() => {
            GetConfigWrapper()
        })
      }

    function GetConfigWrapper() {
        GetConfig().then((res) => {
          setConfig(res.data)
          if (res.data.durationBlock === 1)
            {
              setMinStep(10)
            }
      
            if (res.data.durationBlock === 2){
              setMinStep(15)
            }
      
            if (res.data.durationBlock === 3){
              setMinStep(20)
            }
        }).catch((error) => {
        }).finally(() => {
            // GetEventsWrapper(barbers, new Date(), services)
        })
      }


    function GetEventsWrapper(barbers, queryDate, services) {
      var starts = []
      var ends = []

    
    //   var minStart = new Date(queryDate).setHours(0,0,0,0)
    //   var maxEnd = new Date(queryDate).setHours(23,59,0,0)
    //   if (starts.length > 0 && ends.length > 0) {
    //       minStart = new Date(queryDate).setHours(Math.min.apply(0, starts),0,0,0)
    //       maxEnd = new Date(queryDate).setHours(Math.max.apply(0, ends),0,0,0)
    //       setMinDateTime(minStart)
    //       setMaxDateTime(maxEnd)
    //   } else {
    
    //       setMinDateTime(minStart)
    //       setMaxDateTime(maxEnd)
    //   }
    
    //   if (new Date(queryDate).setHours(0,0,0,0) === new Date(today).setHours(0,0,0,0)) {
    //     setIsSelectedDateToday(true)
    //   } else {
    //     setIsSelectedDateToday(false)
    //   }
    //   setSelectedDate(queryDate);
    
      //setting calendar blocks
      var eventss = []
      barbers.forEach((barber, index) => {
        const day = fullDaysOfWeek[new Date(queryDate).getDay()]
        var startTime = barber[day].start
        const endTime = barber[day].end
    
        if (startTime !== null && endTime !== null)
        {
          if (parseInt(startTime.split(':')[0]) !== Math.min.apply(0, starts))
          {
            var eventt = {
              id : index,
              eventId: index,
              eventType: 'CalendarBlockOut',
              title: '5',
              start: new Date(new Date(queryDate).setHours(0,0,0,0)),
              end: new Date(new Date(queryDate).setHours(parseInt(startTime.split(':')[0]),0,0,0)),
              resourceId: barber.barberId,
              isCalanderBlock: true,
              isResizable: false,
              isDraggable: false,
              colorEvento: '#dedede'
            }
            eventss.push(eventt)
          }
          if (parseInt(endTime.split(':')[0]) !== Math.max.apply(0, ends))
          {
            var eventt = {
              id : index,
              eventId: index,
              eventType: 'CalendarBlockOut',
              title: '',
              start:new Date(new Date(queryDate).setHours(parseInt(endTime.split(':')[0]),0,0,0)), 
              end: new Date(new Date(queryDate).setHours(23,40,0,0)),
              resourceId: barber.barberId,
              isCalanderBlock: true,
              isResizable: false,
              isDraggable: false,
              colorEvento: '#dedede'
            }
            eventss.push(eventt)
          }
    
        } else {
          var eventt = {
            id : index,
            eventId: index,
            eventType: 'CalendarBlockOut',
            title: 'null',
            start: new Date(new Date(queryDate).setHours(0,0,0,0)),
            end: new Date(new Date(queryDate).setHours(23,59,0,0)),
            resourceId: barber.barberId,
            isCalanderBlock: true,
            isResizable: false,
            isDraggable: false,
            colorEvento: '#dedede'
          }
          eventss.push(eventt)
        }
    
      })
    
      //getting events from DB and setting them as calendar events
      GetEvents(queryDate).then((res) => {
        res.data.forEach((event) => {
          var color = barbers.filter(x => x.barberId === event.barberId)[0].barberColour
    
          var eventt = {
            id : event.eventId,
            eventId: event.eventId,
            allDay:false,
            eventType: event.eventType,
            title: event.cancelled ? 'Cancelled' : event.eventType === 3 ? event.recurringFrequency === null ? event.title : String.fromCodePoint(8620) + ' ' + event.title : event.eventType === 2 ? event.title : ((event.isFirstAppointment ? String.fromCodePoint(9733) + ' ' : '') + (event.appointmentNotes !== "" | event.customerNotes !== "" ? String.fromCodePoint(9998) + " " : "" )) + event.firstName + ' - ' + services.filter(x => x.value === event.serviceId)[0].label,
            serviceId: event.serviceId,
            appointmentNotes: event.appointmentNotes,
            isFirstAppointment: event.isFirstAppointment,
            cancelled: event.cancelled,
            cancelledBy: event.cancelledBy,
            cancelledAtUtc: event.cancelledAtUtc,
            customerId: event.customerId,
            firstName: event.firstName,
            lastName: event.lastName,
            phoneNumber: event.phoneNumber,
            email: event.email,
            customerNotes: event.customerNotes,
            customerBlocked: event.blocked,
            start: new Date(event.startDateTime),
            end: new Date(event.endDateTime),
            recurrenceStartDate: event.recurrenceStartDate,
            recurringFrequency: event.recurringFrequency,
            endReccurrenceDate: event.endReccurrenceDate,
            resourceId: event.barberId,
            isCalanderBlock: false,
            isResizable: true,
            isDraggable: !event.cancelled,
            colorEvento: event.cancelled ? 'rgba(190, 190, 190, 0.5)' : event.eventType === 1 ? "#" + color : event.eventType === 2 ?  'pink' : event.eventType === 3 ? 'pink' : 'grey'
          }
    
          eventss.push(eventt)
        })
        setEventData(eventss)
      }).catch((error) => {
          notifyError("Unable to retrieve events, please try again")
      }).finally((f) => {
        hasOverlap(eventss.filter(x => x.eventType === 1), barbers);
      })
    
      }

    function hasOverlap(events, barbers) {
    setBarbersWithClash([])
    var barberIds = []
    if (events.lenth !== 0)
    {
        barbers.forEach(barber => {
        var barberFilteredEvent = events.filter(x => x.resourceId === barber.barberId)
        const sorted = barberFilteredEvent.slice().sort((a, b) => new Date(a.start) - new Date(b.start));
        for (let i = 0; i < sorted.length - 1; i++) {
            const currentEnd = new Date(sorted[i].end);
            const nextStart = new Date(sorted[i + 1].start);
            if (currentEnd > nextStart) {
            // Overlap found
            barberIds.push(sorted[i].resourceId)
            break;
            }
        }
        });
        setBarbersWithClash(barbers.filter(x => barberIds.includes(x.barberId)).map(a => a.name))
    }

    // Then check for any overlap between consecutive time windows
    // setShowCalendar(true)
    }

    function eventClashChecker (eventsToCheck, startDate, endDate) {
      var clash =  false;
      var clashedEvents = []
      eventsToCheck.forEach((elem)=>{
        const test = !((moment(endDate).diff(moment(elem.start))) <= 0 || 
        (moment(startDate).diff(moment(elem.end))) >= 0);
        if (test) {
          clash = true
          clashedEvents.push(elem)
        }
      })
      return clashedEvents
    }
    
    const handleSearch = () => {
        if (keyword !== null && keyword !== undefined && keyword !== "")
        {
            setIsloading(true)
            GetCustomers(keyword).then((res) => {
                setCustomer(res.data)
            }).catch((error) => {
            }).finally(() => {
                setIsloading(false)
            })
        }
        else
        {
            setCustomer("")
        }
    };

    function KeywordHandler(e)
    {
        setKeyword(e.target.value)
        if (e.target.value === "")
        {
            setShowSearchButton(false)
        }
        else{
            setShowSearchButton(true)
        }
    }

    function loadCustomerDetails(customerId) {
        resetCustomerModal()
        var customer = customers.filter(x => x.customerId === customerId)[0]
        setFirstName(customer.customerFirstName)
        setLastName(customer.customerLastName)
        setEmail(customer.customerEmail)
        setMobile(customer.customerMobile)
        setCustomerNotes(customer.customerNotes)
        setCustomerBlocked(customer.customerIsBlocked)
        setCustomerErrors(customerErrorsObj)
      }
    
    function OnCustomerSubmitClick(e)
    {
        e.preventDefault();
        let error = false;
        const customerErrorObj = { ...customerErrorsObj };

        if (firstName === '') {
            customerErrorObj.customerFirstName = 'First name is required';
            error = true;
        }

        if (lastName === '') {
            customerErrorObj.customerLastName = 'Last name is required';
            error = true;
        }

        if(mobile !== undefined && mobile !== null)
        {
        if (mobile.length > 0) {
            if (mobile.length !== 11)
            {
            customerErrorObj.customerMobile = 'Invalid mobile number';
            error = true;
            }
        }
        }

        if (email === '') {
            customerErrorObj.customerEmail = 'Email is required';
            error = true;
        }else
        {
            if (!validEmail.test(email))
            {
                customerErrorObj.customerEmail = 'Invalid Email';
                error = true;
            }
        }

        setCustomerErrors(customerErrorObj);
        if (error) {
        return;
        } else {

        // add customer
        AddCustomer(
            firstName,
            lastName,
            mobile,
            email,
            customerNotes,
            customerBlocked,
            ).then((res) => {
            notifySuccess("Customer Saved")
            var newCustomerObject = {customerId: res.data, firstName:firstName, lastName:lastName, mobile:mobile, email:email, notes:customerNotes, isBlocked:customerBlocked}
            dispatch({type:'addCustomerClose'})
        }).catch((error) => {
            notifyError("Unable to create customer, please try again")

        }).finally((f) => {
            handleSearch()
            resetCustomerModal()
        })
        }
    }

    function resetCustomerModal() {
        setFirstName('')
        setLastName('')
        setMobile()
        setEmail('')
        setCustomerNotes('')
        setCustomerErrors(customerErrorsObj)
        setCustomerBlocked()
        setCustomerDetailsObject()
      }

      function LoadAppointments(customerId)
      {
        var customer = customers.filter(x => x.customerId === customerId)[0]
        console.log(customer)
        var newCustomerObject = {firstName:customer.firstName, lastName:customer.lastName, mobile:customer.phoneNumber, email:customer.customerEmail, notes:customer.customerNotes, isBlocked:customer.customerBlocked, customerId: customerId}
        setCustomerDetailsObject(newCustomerObject)
        // setEmail(customer.customerEmail)
        setPastAppointments([])
        setPastAppointments([])
        setAppointmentsLoading(true)
        GetAppointments(
            customerId
            ).then((res) => {
                setAllAppointments(res.data)
                console.log(res.data.filter(x =>new Date(x.endDateTime) > new Date()))
                setFutureAppointments(res.data.filter(x =>new Date(x.endDateTime) > new Date()))
                setPastAppointments(res.data.filter(x =>new Date(x.endDateTime) < new Date()))
                setAppointmentsLoading(false)
        }).catch((error) => {

        }).finally((f) => {
            
        })
      }
    
    function LoadAppointmentDetails(appointmentId)
    {
        var appointment = allAppointments.filter(x => x.appointmentId === appointmentId)[0]
        GetEventsWrapper(barbers, new Date(appointment.startDateTime), services)
            setIsAppointmentCancelled(appointment.cancelled)
            setAppointmentCancelledByMessage(appointment.cancelled ? 'Cancelled by ' + appointment.cancelledBy + ' on ' + new Date(appointment.cancelledAtUtc).toDateString() +' at ' + new Date(appointment.cancelledAtUtc).getHours() + ':' + new Date(appointment.cancelledAtUtc).getMinutes() : null)
            setSelectedBarber(barberList.filter(x => x.value === appointment.barberId)[0])
            setSelectedService(services.filter(x => x.value === appointment.serviceId)[0]); 
            setStartDateTime(dayjs(appointment.startDateTime))
            setEndDateTime(dayjs(appointment.endDateTime))
            setDuration(timeSelection.filter(x => x.value === ((new Date(appointment.endDateTime).getTime() - new Date(appointment.startDateTime).getTime())/60000)/(config.durationBlock === 1 ? 10 : config.durationBlock === 2 ? 15 : 20))[0])
            setAppointmentNotes(appointment.appointmentNotes)
            setCancelledBy(appointment.cancelledBy)
            setAppointmentIdToEdit(appointmentId)
            // var newCustomerObject = {firstName:e.firstName, lastName:e.lastName, mobile:e.phoneNumber, email:e.email, notes:e.customerNotes, isBlocked:e.customerBlocked}
            // setCustomerDetailsObject(newCustomerObject)
            if (new Date() > new Date(appointment.endDateTime))
            {
              setAppointmentModalDisabled(true)
            }
            else
            {
              setAppointmentModalDisabled(false)
            }
            dispatch({type:'appointmentDetailsOpen'})
    }

     function onSubmitAppointmentClick(e) {

      setCommunicationType("appointment changed")
      // e.preventDefault();
      let error = false;
      const appointmentErrors = { ...appointmentErrorsObj };
    
      if (selectedBarber === undefined || selectedBarber === null) {
        appointmentErrorsObj.barber = 'Required';
        error = true;
      }
    
      if (selectedService === undefined || selectedService === null) {
        appointmentErrorsObj.service = 'Required';
        error = true;
      }
    
      if (startDateTime === undefined || startDateTime === null) {
        appointmentErrorsObj.date = 'Required';
        error = true;
      }
      if (duration === undefined || duration === null) {
        appointmentErrorsObj.duration = 'Required';
        error = true;
      }
      if (customerDetailsObject === null)
      {
        appointmentErrorsObj.customer = "Add a customer"
        error = true
      }
      setAppointmentErrors(appointmentErrorsObj);
      if (error) {
    return;
    } else {
      const calanderAppointmentsForBarber = eventData.filter(x => x.eventType === 1 && x.resourceId === selectedBarber.value && x.eventId !== appointmentIdToEdit)
      const clashedEvents = eventClashChecker(calanderAppointmentsForBarber, new Date(startDateTime), new Date(endDateTime))
      if (clashedEvents.length > 0){
        Swal.fire({
          icon: 'error',
          title: 'Appointment Clash',
          html: `This slot clashes with the following appointments: <b>`
          + clashedEvents.map((clashedEvent) => {return '<br/>' + clashedEvent.title + '&nbsp &nbsp' + ("0" + new Date(clashedEvent.start).getUTCHours()).slice(-2) + ':' + ("0" + new Date(clashedEvent.start).getUTCMinutes()).slice(-2) + ' - ' + ("0" + new Date(clashedEvent.end).getUTCHours()).slice(-2) + ':' + ("0" + new Date(clashedEvent.end).getUTCMinutes()).slice(-2)
        })
      })
      } else {
        const blockOutForBarber = eventData.filter(x => x.eventType === 'CalendarBlockOut' && x.resourceId === selectedBarber.value && x.eventId !== appointmentIdToEdit)
        const clashedEvents = eventClashChecker(blockOutForBarber, new Date(startDateTime), new Date(endDateTime))
        if (clashedEvents.length > 0) {
          Swal.fire({
            icon: 'error',
            title: 'Barber is not working',
            html: `Please choose a different barber`
        })
        }
        else{
        const createdBy = "Barber Shop";
        const calanderHolidaysForBarber = eventData.filter(x => (x.eventType === 2 || x.eventType === 3)  && x.resourceId === selectedBarber.value)
        const clashedWithHolidays = eventClashChecker(calanderHolidaysForBarber, new Date(startDateTime), new Date(endDateTime))
        if (clashedWithHolidays.length > 0){
          Swal.fire({
            title: 'Are you sure you want to edit this appointment',
            text: "You have a holiday during this appointmentt",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: 'var(--primary)',
            cancelButtonColor: '#aaa',
            confirmButtonText: 'Change Holiday'
          }).then((result) => {
            if (result.isConfirmed) {
            EditAppointment(
                appointmentIdToEdit,
                customerDetailsObject.customerId,
                selectedBarber.value,
                selectedService.value,
                startDateTime,
                endDateTime,
                duration.value,
                appointmentNotes,
                customerDetailsObject.firstName,
                customerDetailsObject.lastName,
                customerDetailsObject.mobile,
                customerDetailsObject.email,
                customerDetailsObject.notes,
                customerDetailsObject.isBlocked,
                createdBy,
                true
                ).then((res) => {
                notifySuccess("Appointment Edited")
                dispatch({type:'appointmentDetailsClose'})
                resetAppointmentModal()
                OpenSendCommunicationModal("appointment changed")
                handleSearch()
                LoadAppointments(customerDetailsObject.customerId)
            }).catch((error) => {
                notifyError("Unable to add appointment, please try again")
            }).finally((f) => {
            })

            }
          })
        } else {
          EditAppointment(
            appointmentIdToEdit,
            customerDetailsObject.customerId,
            selectedBarber.value,
            selectedService.value,
            startDateTime,
            endDateTime,
            duration.value,
            appointmentNotes,
            customerDetailsObject.firstName,
            customerDetailsObject.lastName,
            customerDetailsObject.mobile,
            customerDetailsObject.email,
            customerDetailsObject.notes,
            customerDetailsObject.isBlocked,
            createdBy
            ).then((res) => {
            notifySuccess("Appointment Edited")
            dispatch({type:'appointmentDetailsClose'})
            resetAppointmentModal()
            handleSearch()
            LoadAppointments(customerDetailsObject.customerId)
            OpenSendCommunicationModal("appointment changed")
          }).catch((error) => {
            notifyError("Unable to add appointment, please try again")
          }).finally((f) => {
          })
      }
      }
    }
    }
    }

    function selectServiceHandler(e) {
        setSelectedService({value:e.value ,label: e.label}); 
        setDuration(timeSelection.filter(x => x.value === e.duration)[0])
        addDuration(timeSelection.filter(x => x.value === e.duration)[0])
      }

    function addDuration(duration) {
    setDuration(duration)
    if (startDateTime !== undefined && startDateTime !== null)
    {
        var endDateTimeValue = new Date(startDateTime)
        var mins = 0
        if (config.durationBlock === 1){
        mins = duration.value * 10
        }

        if (config.durationBlock === 2){
        mins = duration.value * 15
        }

        if (config.durationBlock === 3){
        mins = duration.value * 20
        }
        endDateTimeValue.setMinutes(endDateTimeValue.getMinutes() + mins)
        setEndDateTime(endDateTimeValue)
    }
    }

    function startDateHandler(e) {
        setStartDateTime(new Date(e))
        if (duration !== undefined)
        {
          var endDateTimeValue = new Date(e)
    
          var mins = 0
          if (config.durationBlock === 1){
            mins = duration.value * 10
          }
    
          if (config.durationBlock === 2){
            mins = duration.value * 15
          }
    
          if (config.durationBlock === 3){
            mins = duration.value * 20
          }
    
          endDateTimeValue.setMinutes(endDateTimeValue.getMinutes() + mins)
          setEndDateTime(endDateTimeValue)
        } 
      }

      function resetAppointmentModal() {
        resetCustomerModal()
        setSelectedBarber()
        setSelectedService()
        setStartDateTime()
        setEndDateTime()
        setDuration()
        setAppointmentNotes('')
        setAppointmentErrors(appointmentErrorsObj)
        setCustomerDetailsObject(null)
      }

      function onCancelAppointment(cancelAppointmentOption) {
        Swal.fire({
          title: cancelAppointmentOption === 0 ? 'Are you sure you want to cancel this appointment' : 'Are you sure you want to reinstate this appointment',
          // text: "You have appointments during this holiday time",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'var(--primary)',
          cancelButtonColor: '#aaa',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No'
        }).then((result) => {
          if (result.isConfirmed) {
            const cancelAppointmentBy = "Barber"
            CancelAppointment(
              appointmentIdToEdit,
              cancelAppointmentOption,
              cancelAppointmentBy
              ).then((res) => {
              notifySuccess("Appointment cancelled")
              dispatch({type:'AddAppointmentClose'})
              if (cancelAppointmentOption === 0)
              {
                setCommunicationType("appointment cancelled")
                OpenSendCommunicationModal("appointment cancelled")
              }
              dispatch({type:'appointmentDetailsClose'})
              handleSearch()
              LoadAppointments(customerDetailsObject.customerId)
            }).catch((error) => {
              notifyError("Unable to cancel appointment, please try again")
            }).finally((f) => {
            })  
          }
        })
      }
    
    function OpenSendCommunicationModal(communicationType){
    if (communicationType === "appointment changed")
    {
        setCustomerAppointmentChangeMessage(config.appointmentChangedMessageToCustomer)
    }
    if (communicationType ===  "appointment cancelled")
    {
        setCustomerAppointmentChangeMessage(config.appointmentCancellationMessageToCustomer)
    }
    dispatch({type:'sendCommunicationOpen'})
    }

  function onSubmitSendCommunicationClick() {

    if (communicationType === "general message")
    {
        SendCommunication(
            communicationType,
            customerDetailsObject.customerId,
            generalMessage
            ).then((res) => {
            notifySuccess("Email Sent")
            dispatch({type:'sendGeneralCommunicationClose'})
            setCommunicationType()
          }).catch((error) => {
            notifyError("Unable to send Email, please try again")
          }).finally((f) => {
          })
    } else
    {
        SendCommunication(
        communicationType,
        appointmentIdToEdit,
        customerAppointmentChangeMessage
        ).then((res) => {
        notifySuccess("Email Sent")
        dispatch({type:'sendCommunicationClose'})
        setCommunicationType()
        }).catch((error) => {
        notifyError("Unable to send Email, please try again")
        }).finally((f) => {
        })
    }
  }

  function LoadGneralCommunication(customerId)
  {
    var customer = customers.filter(x => x.customerId === customerId)[0]
    console.log(customer)
    var newCustomerObject = {firstName:customer.firstName, lastName:customer.lastName, mobile:customer.phoneNumber, email:customer.customerEmail, notes:customer.customerNotes, isBlocked:customer.customerBlocked, customerId: customerId}
    setCustomerDetailsObject(newCustomerObject)
    dispatch({type:'sendGeneralCommunicationOpen'});
    setCommunicationType('general message')
  }

    return (
      // <div className="customer-search-container">
      <div>
        <ToastContainer />
        <div className="search-controls">
          <input
            onKeyDown={(e) => {e.key === "Enter" ? handleSearch(): <></>}}
            type="text"
            className="search-input"
            placeholder="Search customers..."
            defaultValue={keyword}
            onChange={(e) => KeywordHandler(e)}
          />
          <button disabled={!showSearchButton} className={!showSearchButton ? "disabled-search-button" : "search-button"} onClick={handleSearch}>Search</button>
        </div>
        {/* <div style={{border:"3px solid green", width:"100%"}} className="table-wrapper"> */}
        {/* <div className="table-wrapper"> */}
        <div style={{display:'flex', justifyContent:'center', alignItems: 'center'}}>
        <div style={{marginTop:"2rem"}}>
                <PulseLoader 
                    color={'#333'}
                    loading={isLoading}
                    size={25}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                    style={{marginLeft:"auto"}}
                />
            </div>
            </div>
            {isLoading ? <></> :
                    <div className="data-table-wrapper">

        <table className="data-table">

          <thead>
            <tr>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Email</th>
              <th>Blocked</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            
            {customers === "" ? <></>
            :
            customers.map((customer, index) => (
                <tr key={index}>
                  <td>{customer.customerFirstName}</td>
                  <td>{customer.customerLastName}</td>
                  <td>{customer.customerEmail}</td>
                  <td>{customer.customerIsBlocked ? 'Yes' : 'No'
            }
            </td>
                <td className="py-2 text-end">
            <Dropdown autoClose={true} className="dropdown text-sans-serif">
                <Dropdown.Toggle
                    variant=""
                    className="btn tp-btn-light sharp i-false"
                    type="button"
                    id="order-dropdown-0"
                    data-toggle="dropdown"
                    // data-boundary="viewport"
                    aria-haspopup="true"
                    aria-expanded="false"
                    drop="up"
                >
                    <span>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            width="18px"
                            height="18px"
                            viewBox="0 0 24 24"
                            version="1.1"
                        >
                        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                            <rect y={0} width={24} height={24}/>
                            <circle fill="#000000" cx={5} cy={12} r={2}/>
                            <circle fill="#000000" cx={12} cy={12} r={2}/>
                            <circle fill="#000000" cx={19} cy={12} r={2}/>
                        </g>
                        </svg>
                </span>
                </Dropdown.Toggle>
                <Dropdown.Menu
                    className="dropdown-menu dropdown-menu-right border py-0"
                    aria-labelledby="order-dropdown-0"
                >
                    <Dropdown.Item className="dropdown-item" onClick={() => {dispatch({type:'addCustomerOpen'}); loadCustomerDetails(customer.customerId);}}>View Customer</Dropdown.Item>
                    <Dropdown.Item onClick={() => {dispatch({type:'appointmentsOpen'}); LoadAppointments(customer.customerId)}}>View Appointments</Dropdown.Item>
                    <Dropdown.Item onClick={() => {LoadGneralCommunication(customer.customerId)}}>Send Message</Dropdown.Item>
                </Dropdown.Menu>
                </Dropdown>
                </td>
              </tr>
            ))}
          </tbody>
          
        </table>
        </div>
}        
    {customers === "" ? <></>
    
        :
        customers.length === 0
        ?
        <div style={{display:'flex', justifyContent:'center', alignItems: 'center'}}>
        <div style={{marginTop:"2rem"}}>
        <p>No results found for <strong>{keyword}</strong></p>
        </div>
        </div>
        :
        <></>
        }

        {/* </div> */}
              <Modal className="modal fade" show={state.addCustomer} centered>
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Add Customer</h5>
                    <Button variant="" type="button" className="btn-close" data-dismiss="modal" onClick={() => {dispatch({type:'addCustomerClose'}); resetCustomerModal();}}></Button>
                  </div>
                  <div className="modal-body">
                    <form className="" onSubmit={OnCustomerSubmitClick}>
                      <div className="row">

        
                        <div className="col-lg-6">
                          <div className="form-group mb-3">
                            <label htmlFor="author" className="text-black font-w500">  First Name <span className="required">*</span> </label>
                              <input
                                type="text"
                                className="form-control"
                                name="customerFirstName"
                                placeholder=""
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                              />
                              {customerErrors.customerFirstName && <div className="mt-2 text-danger fs-12">{customerErrors.customerFirstName}</div>}
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group mb-3">
                            <label htmlFor="author" className="text-black font-w500">  Last Name <span className="required">*</span> </label>
                              <input
                                type="text"
                                className="form-control"
                                name="customerLastName"
                                placeholder=""
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                              />
                              {customerErrors.customerLastName && <div className="mt-2 text-danger fs-12">{customerErrors.customerLastName}</div>}
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group mb-3">
                            <label htmlFor="author" className="text-black font-w500">Mobile</label>
                              <input
                                type="tel"
                                className="form-control"
                                name="customerMobile"
                                placeholder=""
                                value={mobile}
                                onChange={(e) => setMobile(e.target.value)}
                              />
                              {customerErrors.customerMobile && <div className="mt-2 text-danger fs-12">{customerErrors.customerMobile}</div>}
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group mb-3">
                            <label htmlFor="author" className="text-black font-w500">  Email <span className="required">*</span> </label>
                              <input
                                type="email"
                                className="form-control"
                                name="customerEmail"
                                placeholder=""
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                              />
                              {customerErrors.customerEmail && <div className="mt-2 text-danger fs-12">{customerErrors.customerEmail}</div>}
                          </div>
                        </div>
                          <div className="col-lg-12">
                            <div className="form-group mb-3">
                            <label htmlFor="comment" className="text-black font-w500">Notes</label>
                            <textarea
                              rows={7}
                              className="form-control"
                              name="customerNotes"
                              placeholder=""
                              value={customerNotes}
                              maxLength={250}
                              onChange={(e) => setCustomerNotes(e.target.value)}
                              />
                              {customerErrors.customerNotes && <div className="mt-2 text-danger fs-12">{customerErrors.customerNotes}</div>}
                            </div>
                          </div>
                        <div className='form-check check-switch custom-checkbox me-4 mb-2'>
                            <input
                                type='checkbox'
                                className='form-check-input'
                                id='isBlocked'
                                defaultChecked={customerBlocked}
                                onChange={(e) => { setCustomerBlocked(e.target.checked);}}
                                style={{backgroundColor:customerBlocked ? 'red' : '', borderColor:customerBlocked ? 'red' : ''}}
                            />
                            <label className='form-check-label' htmlFor='isBlocked'>
                                Blocked
                            </label>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group mb-3" style={{display:'flex', justifyContent:'end'}}>
                            <Link to={"#"} className="mt-2 btn-custom btn-primary" onClick={OnCustomerSubmitClick}>Save</Link>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </Modal>
              <Modal className="modal fade" show={state.appointment} centered>
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Appointments</h5>
                    <Button variant="" type="button" className="btn-close" data-dismiss="modal" onClick={() => {dispatch({type:'appointmentsClose'});}}></Button>
                  </div>
                  <div className="modal-body">
                    <form className="" onSubmit={OnCustomerSubmitClick}>
                      <div className="row">
                        <div className="col-lg-12">
                            {appointmentsLoading ?
                            <div>
                                <div style={{display:'flex', justifyContent:'center', alignItems: 'center'}}>
                                    <div style={{marginTop:"2rem"}}>
                                        <PulseLoader 
                                            color={'#333'}
                                            loading={appointmentsLoading}
                                            size={25}
                                            aria-label="Loading Spinner"
                                            data-testid="loader"
                                            style={{marginLeft:"auto"}}
                                        />
                                    </div>
                                </div>
                            </div>    
                            :
                            <div>
                                <h3>Future Appointments</h3>
                                {futureAppointments.length === 0 ? <p>No Appointments</p>
                                :
                                <ul className="appointments-list">
                                    {futureAppointments.map((appointment, index) =>{
                                    return (
                                    <li className={appointment.cancelled ? "cancel-background" : ""}>
                                        {/* <s> */}
                                        {appointment.firstAppointment ? String.fromCodePoint(9733) + ' ' : null}
                                        {barbers.filter(x => x.barberId === appointment.barberId)[0].name}
                                        <span>{DaysToDisplay[new Date(appointment.startDateTime).getDay()]} {new Date(appointment.startDateTime).getDate()} {months[new Date(appointment.startDateTime).getMonth()]} {new Date(appointment.startDateTime).getFullYear()}</span>
                                        {/* </s> */}
                                        <IconButton onClick={() =>{LoadAppointmentDetails(appointment.appointmentId)}} aria-label="delete" size="large" style={{border:"1px solid green", border:"none", padding:0}}>
                                            <CreateIcon />
                                        </IconButton>
                                    </li>
                                    );
                                })}
                                </ul>
                            }
                            <h3 style={{marginTop:"2rem"}}>Past Appointments</h3>
                            {pastAppointments.length === 0 ? <p>No Appointments</p>
                            :
                            <ul className="appointments-list">
                                {pastAppointments.map((appointment, index) =>{
                                    return (
                                    <li style={{color:"#bbb"}}>
                                        {barbers.filter(x => x.barberId === appointment.barberId)[0].name}
                                        <span>{DaysToDisplay[new Date(appointment.startDateTime).getDay()]} {new Date(appointment.startDateTime).getDate()} {months[new Date(appointment.startDateTime).getMonth()]} {new Date(appointment.startDateTime).getFullYear()}</span>
                                        <IconButton onClick={() => {LoadAppointmentDetails(appointment.appointmentId)}} aria-label="delete" size="large" style={{border:"1px solid green", border:"none", padding:0}}>
                                            <CreateIcon />
                                        </IconButton>
                                    </li>
                                    );
                                })}
                            </ul>
                            }
                            </div>
                        }

                        </div>
                    </div>
                </form>
            </div>
            </div>
        </Modal>
      <Modal enforceFocus={false} className="modal fade" show={state.appointmentDetails} centered>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Edit Appointment</h5>
            <Button variant="" type="button" className="btn-close" data-dismiss="modal" onClick={() => dispatch({type:'appointmentDetailsClose'})}></Button>
          </div>
          <div className="modal-body">
            <form className="comment-form" onSubmit={onSubmitAppointmentClick}>
              <div className="row mb-3">
                <div className="col-lg-6  col-md-6  col-sm-6 col-6">
                  <label htmlFor="author" className="text-black font-w500">  Select Barber <span className="required">*</span> </label>
                  <Select
                      placeholder="Barber"
                      closeMenuOnSelect={true}
                      options={barberList}
                      defaultValue={selectedBarber}
                      isDisabled={isAppointmentCancelled || appointmentModalDisabled}
                      onChange={(e) => {setSelectedBarber({value:e.value ,label: e.label})}}
                  />
                  {appointmentErrors.barber && <div className="mt-2 text-danger fs-12">{appointmentErrors.barber}</div>}
                </div>
                <div className="col-lg-6  col-md-6  col-sm-6 col-6">
                  <label htmlFor="author" className="text-black font-w500">  Select Service <span className="required">*</span> </label>
                  <Select
                      placeholder="Services"
                      closeMenuOnSelect={true}
                      options={services}
                      defaultValue={selectedService}
                      isDisabled={isAppointmentCancelled || appointmentModalDisabled}
                      onChange={(e) => {selectServiceHandler(e)}}
                  />
                  {appointmentErrors.service && <div className="mt-2 text-danger fs-12">{appointmentErrors.service}</div>}
                </div>
                <div className="mt-4 col-lg-6  col-md-6  col-sm-6 col-6">
                  <label htmlFor="author" className="text-black font-w500">Choose a Date<span className="required">*</span> </label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                      minutesStep={minStep}
                      reduceAnimations
                      format="DD/MM/YYYY - HH:mm"
                      defaultValue={startDateTime}
                      disablePast
                      disabled={isAppointmentCancelled || appointmentModalDisabled}
                      ampm={false}
                      skipDisabled
                      onChange={(e) => {startDateHandler(e);}}
                    />
                    {appointmentErrors.date && <div className="mt-2 text-danger fs-12">{appointmentErrors.date}</div>}
                  </LocalizationProvider>
                </div>
                <div className="mt-4 col-lg-6  col-md-6  col-sm-6 col-6">
                  <label htmlFor="author" className="text-black font-w500">Change duration<span className="required">*</span> </label>
                  <Select
                    closeMenuOnSelect={true}
                    options={timeSelection}
                    value={duration}
                    isDisabled={isAppointmentCancelled || appointmentModalDisabled}
                    onChange={(e) => addDuration(e)}
                  />
                {appointmentErrors.duration && <div className="mt-2 text-danger fs-12">{appointmentErrors.duration}</div>}
                </div>
                {startDateTime !== undefined && duration !== undefined ?
                <p style={ isAppointmentCancelled || appointmentModalDisabled ? {color:'rgba(200, 200, 200, 0.6)'}: null} className="mt-1 ms-1">
                  {
                  daysOfWeek[new Date(startDateTime).getDay()]
                  + ' '+
                  new Date(startDateTime).getDate()
                  + ' ' +
                  months[new Date(startDateTime).getMonth()]
                  + ' ' +
                  ("0" + new Date(startDateTime).getHours()).slice(-2) +':' + ("0" + new Date(startDateTime).getUTCMinutes()).slice(-2)
                  + ' - ' +
                  ("0" + new Date(endDateTime).getHours()).slice(-2) +':' + ("0" + new Date(endDateTime).getUTCMinutes()).slice(-2)
                  }
                </p>
                :
                null
                }

                <div className="mt-4 col-lg-12">
                  <div className="form-group mb-3">
                  <label htmlFor="comment" className="text-black font-w500">Notes</label>
                  <textarea
                    rows={7}
                    className="form-control"
                    name="customerNotes"
                    placeholder=""
                    disabled={isAppointmentCancelled || appointmentModalDisabled}
                    value={appointmentNotes}
                    maxLength={250}
                    onChange={(e) => setAppointmentNotes(e.target.value)}
                    />
                    {appointmentErrors.appointmentNotes && <div className="mt-2 text-danger fs-12">{appointmentErrors.appointmentNotes}</div>}
                  </div>
                </div>
                <div className="col-lg-12">
                  {true ?
                    <div className="col-lg-12 mb-5">
                    <div className="form-group mb-3" style={{display:'block'}}>

                        {((!isAppointmentCancelled) && (!appointmentModalDisabled)) ?<Link style={{position:'absolute', backgroundColor:'#e83b2e'}} to={"#"} onClick={() => {onCancelAppointment(0)}} className="mt-2 btn-custom btn-primary submit">Cancel</Link>
                        :
                        ((cancelledBy === "Barber") && (!appointmentModalDisabled))
                        ?
                        <Link style={{position:'absolute', backgroundColor:'#e83b2e'}} to={"#"} onClick={() => {onCancelAppointment(1)}} className="mt-2 btn-custom btn-primary submit">Undo</Link>
                        :
                        <></>
                        }
                        {((!isAppointmentCancelled) && (!appointmentModalDisabled)) ? <Link style={{position:'absolute', right:'0', marginRight:'2rem'}} className="mt-2 btn-custom btn-primary" onClick={onSubmitAppointmentClick}>Edit Appointment</Link>: null}
                    </div>
                    </div>
                    
                    :
                    <div style={{display:'flex', justifyContent:'end'}}>
                    <Link to={"#"} className="mt-2 btn-custom btn-primary" onClick={onSubmitAppointmentClick}>Add Appointment</Link>
                    </div>
                  }
                </div>
              </div>
              <p className='fs-14'>{appointmentCancelledByMessage}</p>
            </form>
          </div>
        </div>
      </Modal>
      <Modal enforceFocus={false} className="modal fade" show={state.sendCommunication} centered>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Send Communication</h5>
            <Button variant="" type="button" className="btn-close" data-dismiss="modal" onClick={() => {dispatch({type:'sendCommunicationClose'}); setCommunicationType();}}></Button>
          </div>
          <div className="modal-body">
            <form className="comment-form" onSubmit={onSubmitSendCommunicationClick}>
              <div className="row mb-3">
                <div className="mt-4 col-lg-12">
                  <h6>Email notificationwill be sent to {customerDetailsObject === undefined? '' : customerDetailsObject.email}</h6>
                  <div className="form-group mb-3">
                  <label htmlFor="comment" className="text-black font-w500">Notes</label>
                  <textarea
                    rows={7}
                    className="form-control"
                    name=""
                    placeholder=""
                    defaultValue={customerAppointmentChangeMessage}
                    maxLength={500}
                    onChange={(e) => setCustomerAppointmentChangeMessage(e.target.value)}
                    />
                  </div>
                  {communicationType === "appointment changed" ? <p style={{fontSize:'0.9rem'}}>The new appointment details will be included in the email to the customer</p> : <></>}
                </div>
                <div className="col-lg-12">
                    <div style={{display:'flex', justifyContent:'end'}}>
                    <Link to={"#"} className="mt-2 btn-custom btn-primary" onClick={onSubmitSendCommunicationClick}>Send email</Link>
                    </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Modal>
      <Modal enforceFocus={false} className="modal fade" show={state.sendGeneralCommunication} centered>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Send Communication</h5>
            <Button variant="" type="button" className="btn-close" data-dismiss="modal" onClick={() => {dispatch({type:'sendGeneralCommunicationClose'}); setCommunicationType();}}></Button>
          </div>
          <div className="modal-body">
            <form className="comment-form" onSubmit={onSubmitSendCommunicationClick}>
              <div className="row mb-3">
                <div className="mt-4 col-lg-12">
                  <h6>Email notificationwill be sent to {customerDetailsObject === undefined? '' : customerDetailsObject.email}</h6>
                  <div className="form-group mb-3">
                  <label htmlFor="comment" className="text-black font-w500">Message</label>
                  <textarea
                    rows={7}
                    className="form-control"
                    name=""
                    placeholder=""
                    maxLength={500}
                    onChange={(e) => setGeneralMessage(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-lg-12">
                    <div style={{display:'flex', justifyContent:'end'}}>
                    <Link to={"#"} className="mt-2 btn-custom btn-primary" onClick={() => {onSubmitSendCommunicationClick()}}>Send email</Link>
                    </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Modal>
      </div>
    );
}

export default Search;